import styled from "styled-components";
import { ButtonSettings, Heading } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const ButtonStyled = styled(ButtonSettings)`
  ${props =>
    props.displayBlock &&
    `
    display: block;
    margin: auto;
    margin-top: ${props.theme.spacing.medium};
    width: 35rem;
  `}
`;

export const LogoStyled = styled.div`
  margin-bottom: 0.67em;
  ${props => `text-align: ${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}`};
`;

// Price Component
export const PriceContainer = styled.div`
  margin: 0.7rem 0;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
`;

export const HeadingStyled = styled(Heading)`
  font-size: 1.45rem !important;
  font-weight: normal !important;
  margin: 0;
  margin-bottom: ${props => props.theme.spacing.xsmall};
`;
export const PriceStyled = styled(Heading)`
  // font-size: 1.5rem !important;
  font-weight: normal !important;
`;

export const PriceTimeContainerStyled = styled.div`
  display: flex;
`;
export const PackageTimeStyled = styled(Heading)`
  font-weight: normal !important;
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: ${props =>
  props.theme.spacing.default};
  margin-top: ${props => props.theme.spacing.tiny};
`;
